import React from 'react';
import { Link } from 'react-router-dom';

// Media //
import banner_desktop from '../media/Banner.png';
import banner_mobile from '../media/Banner_mobile.png';
import banner_2_desktop from '../media/Banner2.jpg';
import banner_2_mobile from '../media/Banner2_mobile.jpg';

import logo from '../media/logo_inverse.png';

function HeroSection() {
  return (
    <>
      {/* <section className="w-full bg-gray-900 ">
        <div className="container mx-auto ">
          <img src={banner_desktop} alt="" className="hidden md:block" />
          <img src={banner_mobile} alt="" className="w-full md:hidden" />
        </div>
      </section> */}

      <section className="container relative w-full mx-auto overflow-hidden bg-gray-900">
        <img src={banner_2_desktop} alt="" className="hidden md:block" />
        <div className="absolute inset-0 flex items-center justify-center w-full h-full bg-black/50">
          <div className="absolute flex flex-col items-center">
            <img src={logo} alt="" className="w-56 xl:w-80 lg:w-64" />
            <p className="mt-8 text-2xl font-bold text-center text-blue-500 xl:text-4xl lg:text-3xl">
              Pursuing e-motion
            </p>
            <p className="text-xl text-center text-white xl:text-3xl lg:text-2xl">
              true research
            </p>
          </div>
        </div>
        <img src={banner_2_mobile} alt="" className="w-full md:hidden" />
      </section>

      {/* --- ORIGINALE ---
      <section
        class="relative bg-center bg-no-repeat bg-cover min-h-full"
        style={{ backgroundImage: `url(${background})` }}
      >
        <div class="absolute inset-0 bg-black/75 sm:bg-transparent sm:bg-gradient-to-r sm:from-black/75 sm:to-transparent"></div>
        <div class="container relative px-4 py-32 mx-auto max-w-screen-xl sm:px-6 lg:px-8 lg:h-full lg:items-center lg:flex">
          <div class="max-w-xl text-center sm:text-left text-white">
            <h1 class="font-extrabold text-5xl">
              Il mio super
              <strong class="block font-extrabold text-blue-700">
                Titolone da home
              </strong>
            </h1>

            <p class="max-w-lg mt-4 sm:leading-relaxed sm:text-xl">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nesciunt
              illo tenetur fuga ducimus numquam ea!
            </p>

            <div class="flex flex-wrap mt-8 text-center gap-4">
              <Link
                to="/"
                class="block w-full px-12 py-3 text-sm font-medium text-white rounded shadow bg-blue-600 sm:w-auto active:bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring"
              >
                Get Started
              </Link>

              <Link
                to="/"
                class="block w-full px-12 py-3 text-sm font-medium bg-white rounded shadow text-blue-600 sm:w-auto hover:text-blue-700 active:text-blue-500 focus:outline-none focus:ring"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </section>
      --- FINE ---
      */}
    </>
  );
}

export default HeroSection;
